import { render } from "./AddSpotLight.vue?vue&type=template&id=0187ecae"
import script from "./AddSpotLight.vue?vue&type=script&lang=js"
export * from "./AddSpotLight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__